import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs';
import { NbDialogRef } from '@nebular/theme';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-refresh-token',
  templateUrl: './refresh-token.component.html',
  styleUrls: ['./refresh-token.component.scss'],
})
export class RefreshTokenComponent implements OnInit, OnDestroy {
  @Input() timeout: number;

  private countdown: Subscription;

  constructor(private authService: AuthService, protected dialogRef: NbDialogRef<RefreshTokenComponent>) {
    this.countdown = interval(1000).subscribe((x) => {
      --this.timeout;
      // when timeout is over close the dialog to unsubscribe the countdown and prevent memory leaks
      if (this.timeout <= 0) {
        this.dialogRef.close();
      }
    });
  }

  ngOnInit(): void {}

  refreshToken() {
    this.authService.refreshToken().subscribe(
      (resp) => {
        // console.log(resp);
        if (resp.user) {
          this.authService.setUser(resp.user);
        }
      },
      (error) => console.error(error),
      () => {
        // console.log('then');
        this.dialogRef.close();
      }
    );
  }

  ngOnDestroy(): void {
    this.countdown.unsubscribe();
  }
}
